import React, { useState, useCallback } from "react";
import { connect } from "react-redux";
import { LoadPanel } from "devextreme-react/load-panel";
import TextBox from "devextreme-react/text-box";
import Button from "devextreme-react/button";
import CheckBox from "devextreme-react/check-box";
import axios from "axios";
import { alert, confirm } from 'devextreme/ui/dialog';
function GenerateLotSerialNumbers(props) {
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [generateLot, setGenerateLot] = useState(false);
    const [generateSerial, setGenerateSerial] = useState(false);
    const [generateSerialPct, setGenerateSerialPct] = useState(true);
    const [generateSerialPctUpp, setGenerateSerialPctUpp] = useState(false);
    const [percentage, setPercentage] = useState();
    const position = { of: "#accordion-containe2" };
    const handleGenerateClick = async () => {
        try {
            setLoadPanelVisible(true);
            const payload = {
                generateLot: generateLot,
                generateSerialNumber: generateSerial,
                generateSerialNumberPctOfOrderedQty: generateSerialPct,
                generateSerialNumberPctOfOrderedQtyUpp: generateSerialPctUpp,
                percentage: percentage,
                transactionHeaderRowId: props.headerId
            };
            const response = await axios.post(
                `${window._env_.REACT_APP_APIS}/wm/Lot/GenerateLotSerialNumbers`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${props.oidc.user.access_token}`,
                    },
                }
            );
            props.setGenerateLotSerialNumbers(false);
        } catch (error) {
            console.error("Error:", error);
            alert(error, "Error");
        } finally {
            setLoadPanelVisible(false);
        }
    };
    return (
        <div className="FormMt container-fluid" style={{ height: "96%", paddingTop: "0px" }}>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={() => setLoadPanelVisible(false)}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />
            <div className="row accordianLastRow">
                <div className="col-md-12">
                    <CheckBox
                        text="Generate Lot"
                        value={generateLot}
                        onValueChanged={(e) => setGenerateLot(e.value)}
                        labelMode='static'
                        stylingMode='outlined'
                    />
                </div>
            </div>
            <div className="row accordianLastRow">
                <div className="col-md-12">
                    <CheckBox
                        text="Generate Serial Number"
                        value={generateSerial}
                        onValueChanged={(e) => setGenerateSerial(e.value)}
                        labelMode='static'
                        stylingMode='outlined'
                    />
                </div>
            </div>
            <div className="row accordianLastRow">
                <div className="col-md-12">
                    <CheckBox
                        text="Generate Serial Number - Pct of Ordered Qty"
                        value={generateSerialPct}
                        onValueChanged={(e) => setGenerateSerialPct(e.value)}
                        labelMode='static'
                        stylingMode='outlined'
                    />
                </div>
            </div>
            <div className="row accordianLastRow">
                <div className="col-md-12">
                    <CheckBox
                        text="Generate Serial Number - Pct of Ord Qty / UPP"
                        value={generateSerialPctUpp}
                        onValueChanged={(e) => setGenerateSerialPctUpp(e.value)}
                        labelMode='static'
                        stylingMode='outlined'
                    />
                </div>
            </div>
            <div className="row accordianLastRow">
                <div className="col-md-6">
                    <TextBox
                        id="percentage"
                        value={percentage}
                        onValueChanged={(e) => setPercentage(e.value)}
                        placeholder="Percentage"
                        mode="number"
                        inputAttr={{ min: 1 }}
                        labelMode='static'
                        label='Percentage'
                        stylingMode='outlined'
                    />
                </div>
            </div>
            <div className="row accordianLastRow">
                <div className="col-md-12">
                    <Button
                        text="Generate"
                        type="default"
                        stylingMode="contained"
                        width={120}
                        onClick={handleGenerateClick}
                    />
                </div>
            </div>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(GenerateLotSerialNumbers);